var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { WidgetBody, WidgetSearch, WidgetResults } from "../";
import WidgetModuleOwner from './WidgetModuleOwner';

var UserWidgetBody = (_temp2 = _class = function (_Component) {
    _inherits(UserWidgetBody, _Component);

    function UserWidgetBody() {
        var _temp, _this, _ret;

        _classCallCheck(this, UserWidgetBody);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            q: "",
            filteredOwners: []
        }, _this.componentDidUpdate = function (prevProps, prevState) {

            if (prevProps.owners !== _this.props.owners) {
                _this.filterOwners();
            }

            if (prevState.q !== _this.state.q) {
                _this.filterOwners();
            }
        }, _this.filterOwners = function () {
            var owners = _this.props.owners;
            var q = _this.state.q;


            var filteredOwners = owners.filter(function (owner) {
                var title = owner.title;


                if (q && !title.toLowerCase().includes(q.toLowerCase())) {
                    return false;
                }

                return true;
            });

            _this.setState({
                filteredOwners: filteredOwners
            });
        }, _this.renderOwner = function (owner, index) {

            return React.createElement(WidgetModuleOwner, _extends({}, owner, { key: index }));
        }, _this.renderResults = function () {
            var search = _this.props.search;
            var _this$state = _this.state,
                q = _this$state.q,
                filteredOwners = _this$state.filteredOwners;


            if (!filteredOwners.length) {

                var message = void 0;

                if (search.empty) {
                    message = search.empty;
                }

                message = message.replace("{q}", q);

                return React.createElement(
                    WidgetResults,
                    null,
                    React.createElement(
                        'p',
                        { className: 'admin-widget__empty' },
                        message
                    )
                );
            }

            return React.createElement(
                WidgetResults,
                null,
                filteredOwners.map(_this.renderOwner)
            );
        }, _this.onSearch = function (q, event) {
            event.preventDefault();

            _this.setState({
                q: q
            });
        }, _this.renderSearch = function () {
            var _this$props = _this.props,
                search = _this$props.search,
                owners = _this$props.owners,
                maxOwners = _this$props.maxOwners;
            var q = _this.state.q;


            if (owners.length <= maxOwners) {
                return false;
            }

            if (!search) {
                return false;
            }

            var _ref = search || "{count} owners",
                placeholder = _ref.placeholder;

            placeholder = placeholder.replace("{count}", owners.length);

            return React.createElement(WidgetSearch, _extends({}, search, { placeholder: placeholder, value: q, onChange: _this.onSearch }));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    UserWidgetBody.prototype.componentDidMount = function componentDidMount() {
        this.filterOwners();
    };

    UserWidgetBody.prototype.render = function render() {
        var _props = this.props,
            search = _props.search,
            owners = _props.owners;


        return React.createElement(
            WidgetBody,
            null,
            this.renderSearch(),
            this.renderResults()
        );
    };

    return UserWidgetBody;
}(Component), _class.defaultProps = {
    owners: [],
    maxOwners: 7,
    search: {
        empty: "No hits"
    }
}, _temp2);


export default UserWidgetBody;